import React from "react";
import styled from "styled-components";
import { injectIntl, FormattedMessage } from "react-intl";
import TextF6 from "../TextF6";
import TextF5 from "../TextF5";
import TextF2 from "../TextF2";
import TextF8 from "../TextF8";
import Box from "../Box";
import { themeGet } from "styled-system";
import { MediumContainer } from "../Grid";
import SubmitButton from "../SubmitButton";

const ExcercisesCompleted = styled(TextF2)`
  color: #29264c;
  margin: 0;
  line-height: 1;
`;
const ExcercisesTotal = styled(TextF5)`
  color: #29264c;
  margin: 0;
  line-height: 1;
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  margin-bottom: 0.2rem;
  padding-left: 0.2rem;
  @media screen and (min-width: 38em) {
    margin-bottom: 0.45rem;
  }
`;

const TextF6Regular = styled(TextF6)`
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  font-weight: normal;
`;

const Question = styled(TextF6)`
  margin: 0;
  font-weight: normal;
`;

const Input = styled.input`
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  color: #29264c;
  width: 200px;
  margin-top: 0;
  padding: 0.8rem 1rem;
  font-size: 1rem;
  border: 1px solid rgba(72, 68, 163, 1);
  border-radius: 8px;
  background-clip: padding-box;
`;

const Answer = styled(TextF8)`
  margin-top: 0;
  font-weight: normal;
  margin: 0.5rem 0;
  padding: 4px 16px;
  border-left: 4px solid
    ${props => (props.correctAnswer ? "#19CA94" : "#E02C00")};
  font-family: ${themeGet("fonts.TTNormsProRegular")};
`;

class Widget extends React.Component {
  constructor(props) {
    super(props);
  }

  allAnswered() {
    return (
      this.props.quiz &&
      this.props.quiz.data.items
        .map(
          item =>
            item.id in this.props.answer && this.props.answer[item.id] !== ""
        )
        .every(v => !!v)
    );
  }

  render() {
    const {
      quiz,
      answer,
      submitted,
      submitting,
      messages,
      validation,
      validating,
      onChange,
      onSubmit
    } = this.props;

    if (!quiz || (!!quiz && !quiz.data)) {
      return null;
    }

    const { items } = quiz.data;

    return (
      <div>
        {items.map(item => (
          <div className="question-panel" key={item.id}>
            {!submitted ? (
              <MediumContainer>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  align-items="top"
                  flexDirection={["column", "row", "row"]}
                >
                  <Question>{item.title}</Question>
                  <Box mt={["1rem", "0", "0"]}>
                    <Input
                      type="text"
                      value={answer[item.id] || ""}
                      onChange={e => onChange(e, item.id)}
                      placeholder={this.props.intl.formatMessage({
                        id: "quiz.yourAnswer"
                      })}
                    />
                  </Box>
                </Box>
              </MediumContainer>
            ) : (
              <MediumContainer>
                <TextF6 m={0}>
                  <FormattedMessage id="quiz.youAnswered" />
                </TextF6>
                <TextF6Regular m={0}>{answer[item.id]}</TextF6Regular>
                {!!messages[item.id] ? (
                  <Answer correctAnswer={!messages[item.id].error}>
                    <span>{messages[item.id].message}</span>
                  </Answer>
                ) : null}
              </MediumContainer>
            )}
          </div>
        ))}
        <div className="question-panel">
          <MediumContainer>
            {!submitted ? (
              <Box display="flex" justifyContent="flex-end" align-items="top">
                <SubmitButton
                  onSubmit={() => onSubmit()}
                  submitted={submitted}
                  submitting={submitting}
                  disabled={!this.allAnswered()}
                />
              </Box>
            ) : !validating && !!validation ? (
              <div>
                <TextF8 m={0} color="rgba(41,38,76,0.5)">
                  <FormattedMessage id="quiz.yourScore" />
                </TextF8>
                <Box display="flex" alignItems="flex-end" justifyContent="left">
                  <ExcercisesCompleted>{validation.points}</ExcercisesCompleted>
                  <ExcercisesTotal>/ {validation.maxPoints}</ExcercisesTotal>
                </Box>
              </div>
            ) : null}
          </MediumContainer>
        </div>
      </div>
    );
  }
}

export default injectIntl(Widget);
